export const EVENT_PICK_CATEGORY = '12';
